/* eslint-disable */
import { DateTime } from 'luxon';
import { clubConfig } from 'config/club.config';
/* Get the current instant */
const now = DateTime.now();

const clubEcusson = "assets/images/logo/logo-new.png"
const adversaireEcusson = "/assets/images/ressources/bouclier.png"
const clubName = clubConfig[0].name

export const activities = [
        {
                id: '541416c9-84a7-408a-8d74-27a43c38d797',
                image: clubEcusson,
                clubName: clubName,
                adversaireLogo: '/assets/images/logo/logo-cssp.png',
                opponentName: ' CSSP',
                heure: DateTime.local().hour,
                minutes: DateTime.local().minute,
                description:
                        'RCFMB VS C.S Saint-Pierre',
                date: now.plus({ day: 5 }).toISO(),
                lieu: 'Bonneville' // 5 hours ago

        },
        {
                id: '493190c9-5b61-4912-afe5-78c21f1044d7',
                image: clubEcusson,
                description: 'Entrainement',
                date: now.minus({ minutes: 25 }).toISO(),
                lieu: 'Bonneville',
                type: 'entrainement',
                heure: DateTime.local().hour,
                minutes: DateTime.local().minute,

        },
        {
                id: '6e3e97e5-effc-4fb7-b730-52a151f0b641',
                image: clubEcusson,
                description:
                        'CAB Seniors VS Beaumont Collonges',
                date: now.minus({ day: 1 }).toISO(),
                lieu: 'Bonneville',
                type: 'Match',
                heure: DateTime.local().hour,
                minutes: DateTime.local().minute,

        },

        {
                id: 'b91ccb58-b06c-413b-b389-87010e03a120',
                image: clubEcusson,
                description: 'Entrainement',
                date: now.minus({ day: 2 }).toISO(),
                lieu: 'Bonneville', // 3 hours ago
                type: 'entrainement',
                heure: DateTime.local().hour,
                minutes: DateTime.local().minute,
        },
        // {
        //     id: 'ef7b95a7-8e8b-4616-9619-130d9533add9',
        //     image: clubEcusson,
        //     description:
        //         '<strong>Roger Murray</strong> accepted your friend request',
        //     date: now.minus({ hours: 7 }).toISO(),  // 7 hours ago
        //     extraContent: `You have <span class="font-semibold">8</span> mutual friends.`,
        // },
        // {
        //     id: 'eb8aa470-635e-461d-88e1-23d9ea2a5665',
        //     image: club,
        //     description: '<strong>Sophie Stone</strong> sent you a direct message',
        //     date: now.minus({ hours: 12 }).toISO(), // 9 hours ago
        // },
        // {
        //     id: 'b85c2338-cc98-4140-bbf8-c226ce4e395e',
        //     image: club,
        //     description: 'You have 3 new mails',
        //     date: now.minus({ day: 1 }).toISO(), // 1 day ago
        //     extraContent: `<ol class="list-decimal list-inside space-y-2">
        //                         <li class="font-medium">Please review and sign the attached agreement</li>
        //                         <li class="font-medium">Delivery address confirmation</li>
        //                         <li class="font-medium">Previous clients and their invoices</li>
        //                     </ol>`,
        //     linkedContent: 'Mailbox',
        //     link: '/apps/mailbox',
        //     useRouter: true,
        // },
        // {
        //     id: 'fd0f01b4-f3de-4333-add5-cd86850279f8',
        //     image: club,
        //     description: '<strong>Tina Harris</strong> started a chat with you',
        //     date: now.minus({ day: 2 }).toISO(), // 1 day ago,
        //     linkedContent: 'Go to Chat (Tina Harris)',
        //     link: '/apps/chat/5636c0ba-fa47-42ca-9160-27340583041e',
        //     useRouter: true,
        // },
        // {
        //     id: '8f8e1bf9-4661-4939-9e43-390957b60f42',
        //     image: club,
        //     description:
        //         'Your submission has been accepted and you are ready to sign-up for the final assigment which will be ready in 2 days',
        //     date: now.minus({ days: 3 }).toISO(), // 3 days ago
        // },
        // {
        //     id: '30af917b-7a6a-45d1-822f-9e7ad7f8bf69',
        //     image: club,
        //     description: 'Your Vagrant container is ready to download',
        //     date: now.minus({ day: 4 }).toISO(), // 4 days ago
        // },
];


